var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { ViewSizes } from '../types';
var ViewSmall = /** @class */ (function (_super) {
    __extends(ViewSmall, _super);
    function ViewSmall() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ViewSmall.prototype.render = function () {
        return React.createElement(React.Fragment, null, this.props.children || null);
    };
    Object.defineProperty(ViewSmall, "viewSize", {
        get: function () {
            return ViewSizes.SMALL;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewSmall, "displayName", {
        get: function () {
            return 'viewportView-small';
        },
        enumerable: false,
        configurable: true
    });
    return ViewSmall;
}(React.Component));
export { ViewSmall };
//# sourceMappingURL=view-small.js.map